<template lang="html">
    <div class="main" :class="{'h5_footer':!H5Page}">
        <div class="core">
            <div class="footer_con">
              <div class="left">
          <div class="footer_lsit">
                    <h1>热门产品</h1>
                    <p><router-link :to="{path:'/server'}" >咨询</router-link></p>
                    <p><router-link :to="{path:'/cultivate'}" >培训</router-link></p>
                    <p><router-link :to="{path:'/team'}" >专家团</router-link></p>
                </div>
                <div class="footer_lsit">
                    <h1>金蓝盟生态</h1>
                    <p><router-link :to="{path:'/capital'}" >金合资本</router-link></p>
                    <p><a href="http://www.jlmedu.com/#/index"  target="view_window">商学院</a></p>
                    <p><router-link :to="{path:'/case'}" >客户案例</router-link></p>
                    <p><router-link :to="{path:'/business'}" >商务合作</router-link></p>
                </div>
                <div  class="footer_lsit">
                    <h1>关于我们</h1>
                    <p><router-link :to="{path:'/aboutUs',query:{num:0}}">金蓝盟简介</router-link></p>
                    <p><router-link :to="{path:'/aboutUs',query:{num:1}}" >企业文化</router-link></p>
                    <p><router-link :to="{path:'/aboutUs',query:{num:2}}" >董事长公开信</router-link></p>
                    <p><router-link :to="{path:'/aboutUs',query:{num:3}}" >集团新闻</router-link></p>
                </div>

              </div>
              <div class="right">
                  <div  class="footer_qe">
                    <img src="@/assets/images/public_qe.jpg">
                    <p>关注官方订阅号</p>
                </div>
              </div>
            </div>
            <div class="footer_listbox">
              <ul class="footer_list">
                <li class="tips">友情链接：</li>
                <li v-for="(item,index) in data"><a :href="item.URL" target="view_window">{{item.Name}}</a></li>
              </ul>
            </div>
            <div class="footer_tips"> <a href="https://beian.miit.gov.cn"  target="_blank">皖ICP备2024055328号-7</a>&nbsp;|&nbsp; <!-- 公安备案待主体变更后恢复显示 <a target="_blank" href="https://beian.mps.gov.cn/#/query/webSearch?code=37069302000794" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="@/assets/police.png" style="float:left;"/>
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">鲁公网安备 37069302000794号</p ></a> --> &nbsp;| ©1998-{{ year }} 金蓝盟版权所有</div>
        </div>
    </div>

</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
      data: '',
      year: new Date().getFullYear()
    }
  },
  computed: {
    H5Page () {
      return this.$store.state.isShow
    }
  },
  methods: {
    async getLinks () {
      try {
        const data = await this.$api.common.Links()
        this.data = data
      } catch (e) {}
    }
  },
  created () {
    this.getLinks()
  }
}
</script>
<style lang="scss" scoped>
@import "../styles/mobile.scss";
.core {
  display: block;
  width: 1360px;
  margin: 0 auto;
}
.main {
  padding-bottom: 30px;
  padding-top: 66px;
  background-color: #242a37;
  min-width: 1360px;
  max-width: 1920px;
  display: block;
  margin: 0 auto;
}
.footer_con {
  overflow: hidden;
  padding-bottom: 48px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.09);
  display: flex;
  justify-content: space-between;
  .left {
    display: flex;
    flex: 1;
  }
  .footer_lsit {
    // float: left;
    margin-right:260px;
    h1 {
      font-weight: normal;
      font-size: 18px;
      color: 18px;
      padding-bottom: 8px;
      color: #fff;
      line-height: 25px;
    }
    p a {
      margin-top: 8px;
      font-size: 16px;
      color: #ffffff !important;
      opacity: 0.8;
      line-height: 25px;
    }
  }
  .right {
    width: 180px;
  }
  .footer_qe {
    // float: right;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      display: block;
      width: 140px;
      height: 140px;
    }
    p {
      margin-top: 8px;
      font-size: 18px;
      color: #ffffff;
      opacity: 0.8;
    }
  }
}
.footer_listbox {
  text-align: center;
}
.footer_list {
  margin-top: 26px;
  overflow: hidden;
  display: inline-block;
  vertical-align: top;
  li {
    float: left;
    list-style: none;
    // line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    margin-right: 17px;
    a {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  li.tips {
    margin-right: 8px;
    color: #fff;
  }
  li:nth-last-child(1) {
    margin-right: 0;
  }
}
.footer_tips {
  margin-top: 16px;
  // text-align: center;
  // line-height: 20px;
  // color: rgba(255, 255, 255, 0.3);
  color:#939393;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    // color: rgba(255, 255, 255, 0.3);
    color:#939393;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/com-footer.vue